<script>
	import axios from 'axios';
	import mixin from '../../mixin';

    import Table from './Table.vue';

	export default {
        components: {
            Table,
        },
		mixins: [mixin],
		props: {
			idFromUrl: {
				type: String,
				default: null,
			},
		},
		data() {
			return {
				paymentsData: [],
				columns: [
                    {
                        label: this.$store.getters.getRightText('dossierdetailTableHeadPaymentsCaseNumber'),
                        field: 'dossiernummer',
					},
                    {
                        label: this.$store.getters.getRightText('dossierdetailTableHeadPaymentsPaidAt'),
                        field: 'betaaldbij',
					},
                    {
                        label: this.$store.getters.getRightText('dossierdetailTableHeadPaymentsPaymentDate'),
						field: 'mutatiedatum',
						type: 'date',
					},
                    {
                        label: this.$store.getters.getRightText('dossierdetailTableHeadPaymentsAmount'),
						field: 'bedrag',
						type: 'currency',
                    },
                    {
                        label: this.$store.getters.getRightText('dossierdetailTableHeadPaymentsBookDate'),
						field: 'boekdatum',
                        type: 'date',
                    },
                ],
			};
		},
        computed: {
            sortedPaymentsData() {
                return this.paymentsData.sort((a, b) => {
                    return new Date(b.boekdatum) - new Date(a.boekdatum);
                });
            },
        },
		async mounted() {
			await this.fetchData(this.idFromUrl);
		},
		methods: {
			async fetchData(idFromURL) {
				try {
					const response = await axios.get(
						`/api/dossiers/${idFromURL}/betalingen`
					);
					if (response ?? response.data) {
						this.paymentsData = response.data;
					} else {
						console.error('Invalid data received:', response);
					}
				} catch (error) {
					console.error('Error fetching data:', error);
				}
			},
		},
	};
</script>

<template>
	<div class="deductions mt-1">
		<div class="deductions__table table-container">
			<Table :data="sortedPaymentsData" 
				   :columns="columns" 
				   :exportable="true" 
				   :sortable="true" 
				   :freezable="true" 
				   :scrollable="true" 
				   :text-manipulation="false"
				   :hoverable="false"
				   :alt-style="false"
				   :numbered="true" 
				   export-filename="MijnGGN_Betalingen_Dashboard" />
		</div>
	</div>
</template>


